import type { Recommendation } from '@visiward/schemas';
import { Badge } from '@/components/ui/misc';
import { Target, ArrowRight } from 'lucide-react';

export function RecommendationCard({ rec }: { rec: Recommendation }) {
  return (
    <div className="panel p-5 transition hover:border-accent-blue/40">
      <div className="mb-2 flex items-start justify-between gap-3">
        <h4 className="text-sm font-semibold text-text-primary">{rec.title}</h4>
        <Badge tone={rec.priority}>{rec.priority} priority</Badge>
      </div>
      <p className="mb-3 text-sm text-text-secondary">{rec.reason}</p>
      <div className="mb-3 flex flex-wrap gap-2 text-xs">
        <span className="inline-flex items-center gap-1 rounded-md bg-bg-raised px-2 py-1 text-text-secondary">
          <Target size={12} /> Affects {rec.affectedPrompts} prompt
          {rec.affectedPrompts === 1 ? '' : 's'}
        </span>
        <span className="inline-flex items-center rounded-md bg-bg-raised px-2 py-1 text-text-secondary">
          {rec.expectedVisibilityArea}
        </span>
      </div>
      <div className="rounded-lg border border-border/70 bg-bg-raised/50 p-3">
        <p className="flex items-start gap-2 text-sm text-text-primary">
          <ArrowRight size={15} className="mt-0.5 shrink-0 text-accent-teal" />
          <span>{rec.recommendedAction}</span>
        </p>
      </div>
    </div>
  );
}
